import { dataTextFlowerSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTextFlowerSquare = /*#__PURE__*/createIcon(dataTextFlowerSquare)
export default IconTextFlowerSquare
